module.exports = __webpack_public_path__ + "static/media/subtract-new.579783e3.svg";